/**
 * Botswana pula.
 */
export var BWP = {
  code: 'BWP',
  base: 10,
  exponent: 2
};